import React from "react";
import { StethoscopeIcon } from "lucide-react";
import { CtaButton } from "../CtaButton";
import { Countdown } from "../Countdown";
import { ScarcityBar } from "../ScarcityBar";
export function FinalCta() {
  return <>
      <section className="bg-navy-900 px-5 py-16 text-center md:py-24" data-id="element-135" data-mp="1no6lkc094crq">
        <div className="mx-auto max-w-2xl" data-id="element-136" data-mp="1snay9cmdwsmt">
          <h2 className="font-serif text-3xl font-bold leading-tight text-white md:text-5xl" data-id="element-137" data-mp="1sm84mwxogc37">
            Ready to stop starting from scratch <em className="text-gold-400" data-id="element-138" data-mp="1ipn1yi94rd2j">with every case?</em>
          </h2>
          <p className="mx-auto mt-5 max-w-xl text-[17px] leading-relaxed text-navy-100" data-id="element-139" data-mp="1insht65onozi">
            Start using a visual framework to structure your rhinoplasty case analysis in approximately 15 minutes.
          </p>
          <CtaButton className="mt-8" tone="dark" label="Yes — I want the MasterMap" note="Only $27 · Instant download · Lifetime access · 7-day guarantee" data-id="element-140" data-mp="2z4ej1z0tsxwj" />
          <div className="mt-10 space-y-6" data-id="element-141" data-mp="28lam8gq4x68">
            <Countdown tone="dark" data-id="element-142" data-mp="27ab4kubabkx" />
            <ScarcityBar tone="dark" data-id="element-143" data-mp="3tfo456k1bfjm" />
          </div>
        </div>
      </section>

      <footer className="bg-navy-950 px-5 pb-32 pt-12 text-center" data-id="element-144" data-mp="3tdlewoqphqfy">
        <div className="mx-auto max-w-3xl" data-id="element-145" data-mp="b0x3s2382ypw">
          <div className="flex items-center justify-center gap-2.5" data-id="element-146" data-mp="703eb4a4tbuw">
            <span className="flex h-9 w-9 items-center justify-center rounded-lg bg-gold-400 text-navy-950" data-id="element-147" data-mp="71y0elx53a0k">
              <StethoscopeIcon className="h-5 w-5" aria-hidden="true" data-id="element-148" data-mp="3fhhq5aylqaav" />
            </span>
            <span className="font-serif text-lg font-bold text-white" data-id="element-149" data-mp="3aimz5lqhdffo">Rhinoplasty MasterMap™</span>
          </div>
          <p className="mt-4 text-sm text-navy-100/80" data-id="element-150" data-mp="3odyunvcgn9xn">© 2026 · Dr. Ethan Whitmore – Rhinoplasty MasterMap™. All rights reserved.</p>
          <p className="mt-6 text-xs leading-relaxed text-navy-100/60" data-id="element-151" data-mp="13pb2yl61s131">
            <strong className="text-navy-100/80" data-id="element-152" data-mp="yr15g3wuooe9">Educational disclaimer:</strong> Rhinoplasty MasterMap™ is an educational resource intended exclusively for appropriately qualified medical professionals. It does not constitute individualized medical advice and does not replace formal surgical education, clinical supervision, institutional protocols, current scientific literature, or professional medical judgment. Surgical and clinical outcomes vary by patient and circumstance.
          </p>
        </div>
      </footer>
    </>;
}